import type { CartWithTotals, CartItem } from '@armory-shop/shared';
import { apiFetch } from './client';

/**
 * Получает корзину
 */
export async function getCart(): Promise<CartWithTotals> {
  return await apiFetch<CartWithTotals>('/api/cart');
}

/**
 * Добавляет товар в корзину
 */
export async function addToCart(productId: number, quantity: number = 1): Promise<CartItem> {
  return await apiFetch<CartItem>('/api/cart', {
    method: 'POST',
    body: JSON.stringify({ productId, quantity }),
  });
}

/**
 * Обновляет количество товара в корзине
 */
export async function updateCartItem(itemId: number, quantity: number): Promise<CartItem> {
  return await apiFetch<CartItem>(`/api/cart/${itemId}`, {
    method: 'PUT',
    body: JSON.stringify({ quantity }),
  });
}

/**
 * Удаляет товар из корзины
 */
export async function removeCartItem(itemId: number): Promise<void> {
  await apiFetch<void>(`/api/cart/${itemId}`, {
    method: 'DELETE',
  });
}

/**
 * Очищает корзину
 */
export async function clearCart(): Promise<{ success: boolean; count: number }> {
  return await apiFetch<{ success: boolean; count: number }>('/api/cart', {
    method: 'DELETE',
  });
}
